<template>
  <el-container>
    <el-header>
      <headerModular/>
    </el-header>
    <el-container>
      <el-aside width="260px">
        <navModular class="left-nav" :navPath="navPath"/>
      </el-aside>
      <el-main class="margin-lr-sm">
        <titleModular :pageTitle="pageTitle" :isBack="isBack"/>
        <div class="main-warpper">
          <router-view @setIndex="getIndex(arguments)"/>
        </div>
        <footerModular/>
      </el-main>
    </el-container>


  </el-container>
</template>

<script>


import navModular from '@/components/nav-modular'
import headerModular from '@/components/header-modular'
import titleModular from '@/components/title-modular'
import footerModular from '@/components/footer-modular'
import {getProjectServiceCate} from "@/api/weilao";

export default {
  name: "home",
  components: {
    headerModular,
    navModular,
    titleModular,
    footerModular
  },
  data(){
    return {
      navPath: '',
      pageTitle: '',
      isBack: false,
    }
  },
  created(){
    this.getServerList()
  },
  methods:{
    getIndex(data) {
      this.navPath = data[0]
      this.pageTitle = data[1]
      this.isBack = data[2]
    },
    async getServerList() {
      const res = await getProjectServiceCate()
      if (res.data.length > 0) this.$store.state.server = res.data
    },
  }
}
</script>

<style scoped lang="scss">
.main-warpper {
  height: calc(100vh - 175px);
  overflow: auto;
}
</style>
